module.exports = __webpack_public_path__ + "img/globe.5f9dd14c.svg";